<template>
  <Client />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Client from '@/app/features/ams/client/Client.vue';

  export default defineComponent({
    name: 'ClientPage',
    components: {
      Client,
    },
  });
</script>
